import { addDoc, collection, doc, updateDoc } from 'firebase/firestore'
import React from 'react'
import { auth, db } from '../firebase'
import { useAuthState } from 'react-firebase-hooks/auth'

const ShortTerm = ({currentId}) => {

    const user = useAuthState(auth)
    const desc = "desc comes here"

    const saveData = async () => {
     
      

        if (user){
   
         const date = new Date()
         const usersCollection = collection(db, "users")
         const userDoc = collection(usersCollection, user.uid, "entries")
         
         
         if(currentId==""){
   
           await addDoc(userDoc, {
   
             
     
     
           })
   
         }else {
   
         const entryRef = doc(userDoc, currentId)
   
         await updateDoc(entryRef, {
   
          
   
         })
         }
        }
   
       }


  return (


    <div className='main'>     
        <h2>Short Term Reflection</h2>
        <p></p>

        <h3>Question 1</h3>
    </div>

  )
}

export default ShortTerm